import { Outlet } from 'react-router-dom';
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const SurveyDashboard = lazy(
  () => import("../components/SurveyDashboard")
);

const Survey = lazy(
  () => import("../components/Survey/Survey")
);

const SurveyDashboardRoute: RouteObject = {
  path: '/survey/dashboard',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <Survey />,
    },
    {
      path: ':id',
      element: <SurveyDashboard />,
    },
  ],
};

export default SurveyDashboardRoute;
